/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
import React from 'react'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import CardCompare from './CardCompare'
import styles from './valueCompareGrid.module.scss'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

const getModifiedHtml = tableContent => {
  if (!tableContent) return ''
  const $ = cheerio.load(tableContent, null, false)

  $('p').each((_index, element) => {
    const $p = $(element)
    if ($p.html().trim() === '&nbsp;') {
      $p.remove()
    }
  })

  $('img').attr('loading', 'lazy')
  $('img').attr('decoding', 'async')

  $('a').each((_index, element) => {
    const $a = $(element)
    $a.attr('target', '_blank')
  })

  const modifiedHTML = $.html()
  return modifiedHTML
}

const ValueCompareCardsInGrid = ({ data }) => {
  const { data: productPageContent, isSemPage } = data ?? {}

  const ValueCompareCardsData = productPageContent?.attributes

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.compareCardsRootContainer} ${!isSemPage ? styles.seoStyles : ''} white`}>
        <div
          className={styles.sectionHeading}
          dangerouslySetInnerHTML={{ __html: getModifiedHtml(ValueCompareCardsData?.sectionHeading) }}
        />

        <div className={styles.cardGrid}>
          {ValueCompareCardsData?.valueComparisonCards?.map((item, index) => {
            return <CardCompare data={item} key={index} />
          })}
        </div>
      </div>
    </ErrorBoundary>
  )
}
export default ValueCompareCardsInGrid
